export const idColors = ['#526077', '#4649e5', '#ea670c', '#bc26d3', '#0d9485', '#db2780', '#6d6561', '#713aed', '#028ac7', '#ca9a04', '#16a34a'];
